module.exports = __webpack_public_path__ + "85f733d3b6d3de541e3b7c6b99ecd3a7.pdf";